export enum GeneratorTypeRef {
  very_small = 'very_small',
  small = 'small',
  medium = 'medium',
  big = 'big',
  very_big = 'very_big',
  extremely_big = 'extremely_big'
}
export enum GeneratorTechnology {
  diesel = 'diesel',
  gaz = 'gaz',
  lng = 'lng',
  heavy_fuel_oil = 'heavy_fuel_oil',
  lpg = 'lpg',
  kerosene = 'kerosene'
}
